/**
 * 获取 H5 所处环境
 * 1: 微信浏览器
 * 2: 微信外手机浏览器
 * 3: PC 浏览器
 * 4: 内嵌 Android
 * 5: 内嵌 IOS
 */
const getBrowserType = function() {
    var browser = {
        versions: (function() {
            var u = navigator.userAgent
            return {
                //移动终端浏览器版本信息
                trident: u.indexOf('Trident') > -1, //IE内核
                presto: u.indexOf('Presto') > -1, //opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
                iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //是否iPad
                webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
            };
        })(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
    };
    if (browser.versions.mobile) {
        //判断是否是移动设备打开。browser代码在下面
        var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            // 微信浏览器
            return 1;
        }
        if (browser.versions.ios) {
            // 内嵌 IOS
            // return 5;
			return 2;
        }
        if (browser.versions.android) {
            // 内嵌 Android
            // return 4;
			return 2;
        }
        // 微信外手机浏览器
        return 2;
    } else {
        // PC 浏览器
        return 3;
    }
}

const getLonLat = function(){
	
  if('geolocation' in navigator){
	let options = {
	  enableHighAccuracy: true,
	  timeout: 5000,
	  maximumAge: 0
	}
	function success(position){
	  let lat = position.coords.latitude
	  let lng = position.coords.longitude
	  resolve(position)
	}
	function error(err){
	  console.log("用户拒绝获取位置信息")
	}
	navigator.geolocation.getCurrentPosition(success,error,options)
  }else{
	console.log("无法获取您的位置!")
  }
}

export {
    getBrowserType,getLonLat
}
